import { useEffect, useContext } from 'react';
import {
  FormContext,
  useFormSelector,
  useEventCallback,
} from '@eas/common-web';
import { StepMainFacilityEditForm } from './step-main-facility-edit-types';
import { ProcessForm } from '../irz-facility-split-types';

export function useStepMainFacilityEdit(allValues: ProcessForm) {
  const { setFieldValue } = useContext(FormContext);

  const { irzId } = useFormSelector(
    ({ editData }: StepMainFacilityEditForm) => ({
      irzId: editData?.id,
    })
  );

  const resetValues = useEventCallback(() => {
    setFieldValue('editData', allValues.mainFacility);
  });

  /**
   * If the facility was changed in the first step, we need to reset the form,
   * to have correct default values.
   */
  useEffect(() => {
    if (irzId !== allValues.mainFacility?.id) {
      resetValues();
    }
  }, []);
}
